import { useRef } from "react";
import Text from "../../Components/Text/Text";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import AgilelabsTeamImg from "../../assets/images/home/agilelabs-team.png";
import Img1 from "../../assets/images/home/why-work-with-us/image-1.png";
import Img2 from "../../assets/images/home/why-work-with-us/image-2.png";
import Img3 from "../../assets/images/home/why-work-with-us/image-3.png";

export default function WhyWorkWithUsSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref}>
      <div className="py-[124px] px-4 mx-auto container">
        <Text
          type="h2"
          size="d5"
          className={`mb-16 transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >
          Meet the Visionaries 
          Driving Innovation at Agile Labs
        </Text>
        <div className="gap-16 grid grid-cols-1 md:grid-cols-2 max-lg:grid-cols-1">
          <div className={`flex-1 transition-all duration-700 delay-200 ${show ? "" : "opacity-0 translate-y-96"}`}>
            <div className={`transition-all duration-700 delay-250 ${show ? "" : "opacity-0 translate-y-96"}`}>
              <Text type="h2" size="lg" className="font-semibold mb-6">Who are we?</Text>
              <Text type="p" className="text-lg mb-16">A team of senior engineers, AI specialists, and strategists dedicated to building impactful technology solutions.</Text>
            </div>
            <div className={`transition-all duration-700 delay-300 ${show ? "" : "opacity-0 translate-y-96"}`}>
              <Text type="h1" size="subD2">Why work with us?</Text>
              <div className="flex flex-col gap-9">
                <div className="flex gap-6 items-center">
                  <img src={Img1} alt='Agile Labs' />
                  <Text>Deep expertise in both enterprise and emerging technologies.</Text>
                </div>
                <div className="flex gap-6 items-center">
                  <img src={Img2} alt='Agile Labs' />
                  <Text>A relentless focus on eliminating software waste and driving efficiency.</Text>
                </div>
                <div className="flex gap-6 items-center">
                  <img src={Img3} alt='Agile Labs' />
                  <Text>A delivery model that ensures transparency, adaptability, and measurable impact.</Text>
                </div>
              </div>
            </div>
          </div>
          <div className={`flex-1 transition-all duration-700 delay-200 ${show ? "" : "opacity-0 translate-x-96"}`}>
            <img src={AgilelabsTeamImg} alt={'Agile Labs'} className="rounded-3xl" />
          </div>
        </div>
      </div>
    </section>
  );
}
